<template>
  <div class="q-pt-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      :rows="rows"
      title="Produtos do grupo"
      :columns="columns"
      :loading="disable"
      class="tabela-tamanho-fixo"
      title-class="text-brand-5 text-weight-bold"
      v-model:pagination="pagination"
      hide-pagination
      dense
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="300"
          v-model="filter"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-created_at="props">
        <q-td>
          {{
            props.row.created_at.split(" ")[0].split("-").reverse().join("/")
          }}
          {{ props.row.created_at.split(" ")[1] }}
        </q-td>
      </template>

      <template #body-cell-price="props">
        <q-td>
          R$
          {{ Number(props.row.pivot.price).toFixed(2) }}
        </q-td>
      </template>
      <template #body-cell-delete="props">
        <q-td>
          <q-btn
            color="negative"
            icon="delete"
            flat
            dense
            round
            @click="removerProduto(props.row)"
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "Codigo",
    field: (row) => row.code,
    align: "left",
    style: "white-space: normal",
  },

  {
    name: "description",
    label: "Descrição",
    field: (row) => row?.pivot?.contract_product_description,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "categoria",
    label: "Categoria",
    field: (row) =>
      row.pivot.product_category
        ? row.pivot.product_category.code
        : "Sem Categoria",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "description",
    label: "CA",
    field: (row) =>
      row.pivot && row.pivot.ca != null ? row.pivot.ca.code : "Sem CA",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "price",
    label: "Preço",
    field: "price",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "delete",
    label: "Remover",
    field: "delete",
    align: "left",
    style: "white-space: normal",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";

export default {
  props: ["associacao", "atualizar", "id", "contratoId"],
  setup(props) {
    const $q = useQuasar();
    const route = useRoute();
    const store = useStore();
    const rows = ref([]);
    const disable = ref(false);
    const unidadeSelect = ref("");
    let filter = ref("");
    const dados = route.params.id ? JSON.parse(route.params.id) : "";

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 1000,
      rowsNumber: 15,
    });

    const getProdutos = async () => {
      disable.value = true;
      try {
        let response = await store.dispatch("centroDeCusto/produtosGrupo", {
          unidade:
            props.contratoId == ""
              ? store.state.org.unidadeData.id
              : props.contratoId,

          search: filter.value,
          group_id: props.id,
        });
        if (response.data?.model[0]?.products?.length == 0) {
          $q.notify({
            message: "Esse grupo não possui produtos",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          rows.value = [];
          return;
        }

        rows.value = response.data?.model[0]?.products;

        disable.value = false;
      } catch (error) {
        disable.value = false;
        console.log(error);
      }
    };

    const handleRequest = async () => {
      getProdutos(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getProdutos();
        }, 1500);
      }
    );

    watch(
      () => props.contratoId,
      () => {
        setTimeout(() => {
          getProdutos();
        }, 1500);
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        getProdutos();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidadeSelect.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const removerProduto = async (row) => {
      try {
        let dadosProduto = [{ product_id: row.id, product_group_id: null }];
        await store.dispatch("grupoProdutos/adicionarProdutoGrupo", {
          products: dadosProduto,
          contract_id: props.contratoId,
        });

        getProdutos();
        $q.notify({
          message: "Produto removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o remover produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      dados,
      columns,
      rows,
      getProdutos,
      pagination,
      handleRequest,
      disable,
      filter,
      unidadeSelect,
      removerProduto,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
